<template>
  <div class="garantie-view">
    <div class="garantie-view__head">
      <div class="garantie-view__head--icon" @click="$router.push('/devis')" v-if="showRetourButton">
        <font-awesome-icon prefix="fas" icon="arrow-circle-left" />
        Retour
      </div>
    </div>
    <div class="garantie-view__head">
      <div class="garantie-view__head--title">Devis en ligne</div>
    </div>
    <div class="garantie-view__body">
      <div class="garantie-view__body__block">
        <div class="garantie-view__body__block--title">
          Informations sur le propriétaire du Camping-Car :
        </div>
        <div class="garantie-view__body__block--content" v-if="!isBusy && guaranty && guaranty.client">
          <div class="title">Vos coordonnées :</div>
          <div class="row">
            <template v-if="+guaranty.client.civility !== CLIENT_CIVILITY.SOCIETE.ID">
              <div class="col-12">
                <div class="field">
                  <div class="field__label">Civilité :</div>
                  <div class="field__value">{{ showGender }}</div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="col-12">
                <div class="field">
                  <div class="field__label">Société :</div>
                  <div class="field__value">
                    {{ guaranty.client.name_of_signatory }}
                  </div>
                </div>
              </div>
            </template>

            <template v-if="+guaranty.client.civility !== CLIENT_CIVILITY.SOCIETE.ID">
              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Nom :</div>
                  <div class="field__value">
                    {{ guaranty.client.last_name || "" }}
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6" v-if="guaranty.client.first_name">
                <div class="field">
                  <div class="field__label">Prénom :</div>
                  <div class="field__value">
                    {{ guaranty.client.first_name || "" }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="col-12 col-md-6">
                <div class="field">
                  <div class="field__label">Nom du signataire :</div>
                  <div class="field__value">
                    {{ guaranty.client.last_name || "" }}
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6" v-if="guaranty.client.first_name">
                <div class="field">
                  <div class="field__label">Prénom du signataire :</div>
                  <div class="field__value">
                    {{ guaranty.client.first_name || "" }}
                  </div>
                </div>
              </div>
            </template>

            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Adresse :</div>
                <div class="field__value">
                  {{ guaranty.client.address || "" }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Code postal :</div>
                <div class="field__value">{{ guaranty.client.zip || "" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Ville :</div>
                <div class="field__value">{{ guaranty.client.city || "" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Téléphone :</div>
                <div class="field__value">{{ guaranty.client.tel || "" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Fax :</div>
                <div class="field__value">{{ guaranty.client.fax || "" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Email :</div>
                <div class="field__value">
                  {{ guaranty.client.email || "" }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6"
              v-if="guaranty.client && guaranty.client.birthday && guaranty.client.birthday != '1900-01-01 00:00:00'">
              <div class="field">
                <div class="field__label">Date de naissance :</div>
                <div class="field__value">{{ parseBirthDate(guaranty) }}</div>
              </div>
            </div>
            <!--<div class="col-12 col-md-6">-->
            <!--<div class="field">-->
            <!--<div class="field__label">Date de naissance:</div>-->
            <!--<div class="field__value">{{parseBirthDate(guaranty)}}</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="col-12 col-md-6">-->
            <!--<div class="field">-->
            <!--<div class="field__label">Situation familiale:</div>-->
            <!--<div class="field__value">{{showFamilyStatus}}</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="col-12 col-md-6">-->
            <!--<div class="field">-->
            <!--<div class="field__label">Profession:</div>-->
            <!--<div class="field__value">{{showProfession}}</div>-->
            <!--</div>-->
            <!--</div>-->
          </div>
        </div>
        <div class="garantie-view__body__block--content" v-else-if="!isBusy && guaranty">
          <div class="title">Vos coordonnées :</div>
          <div class="row">
            <div class="col-12">
              <div class="field">
                <div class="field__label">Civilité :</div>
                <div class="field__value">{{ guaranty.civility == 1 ? 'Mme' : 'M' }}</div>
              </div>
            </div>

            <div class="col-12 col-md-6" v-if="guaranty.last_name">
              <div class="field">
                <div class="field__label">Nom :</div>
                <div class="field__value">
                  {{ guaranty.last_name || "" }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6" v-if="guaranty.first_name">
              <div class="field">
                <div class="field__label">Prénom :</div>
                <div class="field__value">
                  {{ guaranty.first_name || "" }}
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Adresse :</div>
                <div class="field__value">
                  {{ guaranty.address || "" }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Code postal :</div>
                <div class="field__value">{{ guaranty.zip || "" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Ville :</div>
                <div class="field__value">{{ guaranty.city || "" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Téléphone :</div>
                <div class="field__value">{{ guaranty.tel || "" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Fax :</div>
                <div class="field__value">{{ guaranty.fax || "" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Email :</div>
                <div class="field__value">
                  {{ guaranty.email || "" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Preloader v-if="isBusy" />
        <div class="garantie-view__body__block--title">
          Informations sur le Camping-car à assurer :
        </div>
        <div class="garantie-view__body__block--content" v-if="!isBusy && guaranty.details">
          <div class="title">Votre Camping-car :</div>
          <div class="row">
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Voiture neuve :
                </div>
                <div class="field__value">
                  {{ getIsNew() }}
                </div>
              </div>
            </div>
            <div class="col-12" v-if="guaranty.details.cardans">
              <div class="field">
                <div class="field__label field__label--bold">
                  Cardans, mécanisme d’embrayage, maître-cylindre et assistance
                  de freinage :
                </div>
                <div class="field__value">
                  {{ guaranty.details.cardans || "" }}
                </div>
              </div>
            </div>
            <div class="col-12" v-if="guaranty.details.pumps">
              <div class="field">
                <div class="field__label field__label--bold">
                  Pompe à eau, radiateur, moto ventilateur, alternateur,
                  démarreur :
                </div>
                <div class="field__value">
                  {{ guaranty.details.pumps || "" }}
                </div>
              </div>
            </div>
            <div class="col-12" v-if="guaranty.details.injections">
              <div class="field">
                <div class="field__label field__label--bold">
                  Turbo, pompe à injection :
                </div>
                <div class="field__value">
                  {{ guaranty.details.injections || "" }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Type de garantie :
                </div>
                <div class="field__value">{{ showGuaranty }}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">Durée :</div>
                <div class="field__value">{{ showDuration }}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Immatriculation :
                </div>
                <div class="field__value">
                  {{ guaranty.details.registration || "" }}
                </div>
              </div>
            </div>
            <!--<div class="col-12">-->
            <!--<div class="field">-->
            <!--<div class="field__label field__label&#45;&#45;bold">Précédant numéro d'immatriculation:</div>-->
            <!--<div class="field__value">{{guaranty.details.registration_old_number || ''}}</div>-->
            <!--</div>-->
            <!--</div>-->
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Marque du porteur :
                </div>
                <div class="field__value">
                  {{ guaranty.details.marque_porteur || guaranty.details_camping_car.marque_porteur || "" }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Modèle du porteur :
                </div>
                <div class="field__value">
                  {{ guaranty.details.modele_porteur || guaranty.details_camping_car.modele_porteur || "" }}
                </div>
              </div>
            </div>
            <!--            <div class="col-12">-->
            <!--              <div class="field">-->
            <!--                <div class="field__label field__label&#45;&#45;bold">-->
            <!--                  Marque cellule :-->
            <!--                </div>-->
            <!--                <div class="field__value">-->
            <!--                  {{ guaranty.details.marque_cellule || "" }}-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="col-12">-->
            <!--              <div class="field">-->
            <!--                <div class="field__label field__label&#45;&#45;bold">-->
            <!--                  Modèle cellule :-->
            <!--                </div>-->
            <!--                <div class="field__value">-->
            <!--                  {{ guaranty.details.modele_cellule || "" }}-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Date de 1ère mise en circulation :
                </div>
                <div class="field__value">
                  {{ parseCirculationDate(guaranty.details) || parseCirculationDate(guaranty.details_camping_car) || ""
                  }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Numéro de série :
                </div>
                <div class="field__value">
                  {{ guaranty.details.serial_number || "" }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Puissance fiscale :
                </div>
                <div class="field__value">
                  {{ guaranty.details.fiscal_power || "" }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Date d'effet :
                </div>
                <div class="field__value">
                  {{ parseEffectiveDate(guaranty.details) }}
                </div>
              </div>
            </div>
            <!--<div class="col-12">-->
            <!--<div class="field">-->
            <!--<div class="field__label field__label&#45;&#45;bold">Date de la vente:</div>-->
            <!--<div class="field__value">{{parseSaleDate(guaranty.details)}}</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="col-12">-->
            <!--<div class="field">-->
            <!--<div class="field__label field__label&#45;&#45;bold">Date de la livraison:</div>-->
            <!--<div class="field__value">{{parseDeliveryDate(guaranty.details)}}</div>-->
            <!--</div>-->
            <!--</div>-->
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">Kilométrage :</div>
                <div class="field__value">
                  {{ guaranty.details.km_real || "" }}
                </div>
              </div>
            </div>
            <!--<div class="col-12">-->
            <!--<div class="field">-->
            <!--<div class="field__label field__label&#45;&#45;bold">Km compteur:</div>-->
            <!--<div class="field__value">{{guaranty.details.km_counter || ''}}</div>-->
            <!--</div>-->
            <!--</div>-->
            <div class="col-12">
              <div class="field">
                <div class="field__label field__label--bold">
                  Assistance souhaitée :
                </div>
                <!--<div class="field__value">{{guaranty.details.assistance || ''}}</div>-->
                <div class="field__value">{{ showAssistance }}</div>
              </div>
            </div>

            <div class="col-12" v-if="guaranty.finance == 1">
              <div class="field">
                <div class="field__label field__label--bold">
                  Organisme de financement :
                </div>
                <div class="field__value">{{ guaranty.finance_name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="garantie-view__body__block--warning"
          v-if="guaranty.details && guaranty.details.registration && numberOfDuplicates > 0">
          Attention ! Un contrat a déjà été saisi avec ce nom et ce numéro
          d’immatriculation.
        </div>
        <div class="garantie-view__body__block--link">
          <router-link :to="/garantie-camping-car/ + $route.params.id">Cliquer ici pour modifier vos coordonnées
          </router-link>
        </div>
        <Preloader v-if="isBusy" />
      </div>
      <div class="garantie-view__body__block mt-3">
        <div class="garantie-view__body__block--title">
          VOUS AVEZ CHOISI LA GARANTIE {{ showGuaranty }} POUR UNE DURÉE DE {{ showDuration }}
        </div>

        <div class="garantie-view__body__block--content">
          <div class="description">
            <div class="label mb-2">
              <div class="label--bold rem-18">
                Dur&eacute;e et prise d'effet
              </div>
            </div>

            <div class="font-weight-bold rem-14" v-if="mechanicCode != '705223'">
              Sous r&eacute;serve du paiement de la prime et de l'acceptation de
              la garantie par <strong>Dynassurances</strong>, la garantie
              s'applique suivant la dur&eacute;e pr&eacute;cis&eacute;e aux
              conditions particuli&egrave;res du contrat et prendra fin
              automatiquement &agrave; 24 heures jour pour jour selon les dates
              indiqu&eacute;es sur le certificat de garantie.
              <br />
              Cependant la garantie prendra fin de plein droit avant son terme :
            </div>
            <div class="font-weight-bold rem-14" v-else>
              Sous r&eacute;serve du paiement de la prime et de l'acceptation de
              la garantie, la garantie s'applique suivant la dur&eacute;e
              pr&eacute;cis&eacute;e aux conditions particuli&egrave;res du
              contrat et prendra fin automatiquement &agrave; 24 heures jour
              pour jour selon les dates indiqu&eacute;es sur le certificat de
              garantie.
              <br />
              Cependant la garantie prendra fin de plein droit avant son terme :
            </div>

            <div class="list mt-3 rem-14">
              <ul class="list__ul font-weight-bold">
                <li>
                  en cas de destruction du v&eacute;hicule, quelle qu'en soit la
                  cause, par r&eacute;siliation,
                </li>
                <li>
                  en cas de d&eacute;ch&eacute;ance du
                  b&eacute;n&eacute;ficiaire de la garantie pour non respect des
                  prescriptions du constructeur sur l'usage pour lequel le
                  v&eacute;hicule est con&ccedil;u.
                </li>
              </ul>
            </div>
            <br class="mt-5" />
            <div class="label mt-5">
              <div class="label--bold">Véhicules couverts</div>
            </div>
            <div class="font-weight-bold">
              Tout véhicule camping car de moins de 5 tonnes, et moins de
              120.000 kilomètres à la souscription, sauf véhicule de location.
            </div>
            <div class="price-block">
              <div class="divider mt-4 mb-4"></div>

              <div class="row mt-3">
                <div class="col-12 col-md-6">
                  <div class="label">
                    <div class="label--bold">
                      Prime totale T.T.C. (&euro;) *
                    </div>
                  </div>
                </div>

                <template v-if="getPrice && checkValidPTC">
                  <div class="col-12 col-md-6">
                    <div class="label">
                      <div class="label--bold">
                        {{ getPrice }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="col-12 col-md-6">
                    <div class="label">
                      <div class="label--red" v-if="mechanicCode != '705223'">
                        Les critères du véhicule ne permettent pas de souscrire
                        à la garantie choisie.<br />
                        Pour effectuer une demande de dérogation, veuillez
                        adresser le contrôle technique à l’adresse
                        <a href="mailto:servicetechnique@dynassurances.fr">servicetechnique@dynassurances.fr</a>
                        avec les informations suivantes :
                        <ul>
                          <li>Immatriculation du véhicule</li>
                          <li>Votre code garage</li>
                        </ul>
                      </div>
                      <div class="label--red" v-else>
                        Les critères du véhicule ne permettent pas de souscrire
                        à la garantie choisie.<br />
                        Pour effectuer une demande de dérogation, veuillez
                        adresser le contrôle technique avec les informations
                        suivantes :
                        <ul>
                          <li>Immatriculation du véhicule</li>
                          <li>Votre code garage</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div class="row mt-3" v-if="guaranty && +guaranty.details <= 0">
                <div class="col-12 col-md-7">
                  <div class="label">
                    <div class="label--bold">
                      Dont pack assistance pour une durée de 1 an
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-5">
                  <div class="label">
                    <div class="label--bold">
                      {{
                        roundEURWithoutSymbol(
                          guaranty.assistance_price
                        ).replace(".", ",")
                      }}
                      €
                    </div>
                  </div>
                </div>
              </div>

              <div class="agenda mt-3">
                <div class="agenda--small">
                  * Frais de dossier et taxe attentats inclus
                </div>
              </div>

              <div class="divider mt-4 mb-4"></div>
            </div>
            <div class="insurance-info">
              <div class="insurance-info__buttons">
                <div class="insurance-info__buttons__item insurance-info__buttons__item--50 text-sm-right">
                  <div class="insurance-info__buttons--wrapper">
                    <a href="#" @click.prenevt="printInsurance()" class="blue">Imprimer le détail de la garantie</a>
                    <div class="ball-anchor blue"></div>
                  </div>
                </div>
                <div class="insurance-info__buttons__item insurance-info__buttons__item--50 text-sm-left">
                  <div class="insurance-info__buttons--wrapper" v-if="mechanicCode != '705223'">
                    <a href="#" @click.prenevt="getFrontPdf()" class="green">Sauvegarder sur mon ordinateur</a>
                    <div class="ball-anchor green"></div>
                  </div>
                  <div class="insurance-info__buttons--wrapper" v-else>
                    <a href="#" @click.prenevt="getFrontPdfWL()" class="green">Sauvegarder sur mon ordinateur</a>
                    <div class="ball-anchor green"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="print-page-break"></div>

        <div class="garantie-view__body__block mt-3">
          <div class="garantie-view__body__block--title">
            Garanties accordées
          </div>
          <div class="garantie-view__body__block--content">
            <div class="description">
              <div class="label mt-5">
                <div class="label--bold">
                  POUR LE PORTEUR
                </div>
              </div>
            </div>
          </div>

          <div v-if="guaranty.details && guaranty.details.garantie == 1">
            <div class="garantie-view__body__block--content" v-if="!is_LeMondeCampingCar">
              <div class="description">
                <p>
                  <strong>Dans le Moteur</strong> : Arbre à cames, coussinets de bielles, bielles, culbuteurs, tiges de
                  culbuteurs, poussoirs, chaines de distribution, courroie de distribution (uniquement en cas de
                  rupture),
                  paliers de vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides, pompe à huile,
                  culasse
                  et joint de culasse et turbo.
                </p>
                <p><strong>Dans la Boite de vitesses</strong> :</p>
                <p>
                  <strong>Manuelle</strong> : Toutes les défaillances internes : Pignons, arbres, sélecteurs, synchros,
                  roulements.
                </p>
                <p>
                  <strong>Automatique</strong> : Pignons, pompe à huile, bagues et arbres, convertisseur de couple,
                  vannes et
                  soupapes, régulateur, plateau.
                </p>
                <p>
                  <strong>Dans le dispositif de transmission</strong> : Boîte de transfert, pont arrière, différentiels,
                  pignons et couronnes. A l’exclusion des arbres de roues, de transmission et des cardans.
                </p>
                <p>
                  <strong>Pour la cellule</strong> : Pompe à eau, carte électronique chauffe-eau, agrégat réfrigérateur,
                  transformateur et chargeur électrique, pulseur d’air, carte électronique du , à l’exception des
                  faisceaux.
                  Les problèmes d’étanchéité (couverture des dommages résultant d’une modification anormale de la
                  cellule, à
                  l’exception des baies et des ouvrants, si la périodicité des contrôles annuels prévus par le
                  constructeur a
                  été respectée).
                </p>
                <p>
                  <strong>Les pièces de la cellule </strong> : pompe à eau, Carte électronique chauffe-eau, agrégat
                  réfrigérateur, transformateur et chargeur électrique, pulseur d’air, carte électronique du
                  réfrigérateur, à
                  l’exception des faisceaux. Les problèmes d’étanchéité (couverture des dommages résultant d’une
                  modification
                  anormale de la cellule, à l’exception des baies et des ouvrants, si la périodicité des contrôles
                  annuels
                  prévus par le constructeur a été respectée).
                </p>
                <p>
                  <strong>Important </strong> : Cette garantie est réservée aux camping-cars de moins de 5 tonnes et
                  moins de
                  120 000 kilomètres à la souscription.
                </p>
              </div>
            </div>
            <div v-else>
              <div class="garantie-view__body__block--content">
                <h4 class="ql-align-center">
                  <strong>LES PIÈCES GARANTIES (PORTEUR)</strong>
                </h4>
                <div class="description">
                  <div class="list mt-3">
                    <ul class="list__ul">
                      <li>
                        <b>Dans le Moteur :</b>
                        <div>
                          Arbre à cames, coussinets de bielles, bielles, culbuteurs, tiges de
                          culbuteurs, poussoirs, chaines de distribution, courroie de distribution
                          (uniquement en cas de rupture), paliers de vilebrequin, vilebrequin, pistons
                          et axes, segments, soupapes et guides, pompe à huile, culasse et joint de
                          culasse et turbo.
                        </div>
                      </li>
                      <li>
                        <b>Dans la Boite de vitesses :</b>
                        <div>
                          Manuelle : Toutes les défaillances internes : Pignons, arbres, sélecteurs,
                          synchros, roulements.
                        </div>
                        <div>
                          Automatique : Pignons, pompe à huile, bagues et arbres, convertisseur de
                          couple, vannes et soupapes, régulateur, plateau.
                        </div>
                      </li>
                      <li>
                        <b>Dans le dispositif de transmission :</b>
                        <div>
                          Boîte de transfert, pont arrière, différentiels, pignons et couronnes. A
                          l’exclusion des arbres de roues, de transmission et des cardans.
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="guaranty.details && guaranty.details.garantie == 2">
            <div class="garantie-view__body__block--content" v-if="!is_LeMondeCampingCar">
              <div class="description">
                <p>
                  <strong>Dans le Moteur</strong> : Arbre à cames, coussinets de bielles, bielles, culbuteurs, tiges de
                  culbuteurs, poussoirs, chaines de distribution, courroie de distribution (uniquement en cas de
                  rupture),
                  paliers de vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides, pompe à huile,
                  culasse
                  et joint de culasse et turbo.
                </p>
                <p><strong>Dans la Boite de vitesses</strong> :</p>
                <p>
                  <strong>Manuelle</strong> : Toutes les défaillances internes : Pignons, arbres, sélecteurs, synchros,
                  roulements.
                </p>
                <p>
                  <strong>Automatique</strong> : Pignons, pompe à huile, bagues et arbres, convertisseur de couple,
                  vannes et
                  soupapes, régulateur, plateau.
                </p>
                <p>
                  <strong>Dans le dispositif de transmission</strong> : Boîte de transfert, pont arrière, différentiels,
                  pignons et couronnes. A l’exclusion des arbres de roues, de transmission et des cardans.
                </p>
                <p>
                  <strong>Dans le dispositif de refroidissement</strong> : Radiateur d'eau, pompe à eau, ventilateur.
                </p>
                <p>
                  <strong>Dans le système électrique</strong> : Alternateur, démarreur, serrure de porte, moteurs et
                  mécanismes de lèves vitres, moteurs d'essuie glace et de toit ouvrant, compresseur et condenseur de
                  climatisation à l’exception de la recharge de gaz.
                </p>
                <p>
                  <strong>Dans le système de direction</strong> : Crémaillère ou boîtier, pompe d'assistance, à
                  l'exception de
                  la colonne, des rotules et biellettes.
                </p>
                <p>
                  <strong>Dans le système de freinage</strong> : Maître cylindre, servofrein, répartiteur, pompe à vide,
                  bloc
                  hydraulique ABS.
                </p>
                <p>
                  <strong>Dans le système d’alimentation</strong> : Allumeur, module électronique d'allumage, bobine,
                  pompe à
                  injection, boîtier électronique d'injection, pompes d'alimentation en carburant, boitier papillon
                  d’injection, débitmètre, vanne EGR. A l'exception des injecteurs.
                </p>
                <p>
                  <strong>Dans le dispositif d’embrayage</strong> : Mécanisme, fourchette, émetteur, récepteur.
                </p>
                <p>
                  <strong>Pour la cellule</strong> : Pompe à eau, carte électronique chauffe-eau, agrégat réfrigérateur,
                  transformateur et chargeur électrique, pulseur d’air, carte électronique du , à l’exception des
                  faisceaux.
                  Les problèmes d’étanchéité (couverture des dommages résultant d’une modification anormale de la
                  cellule, à
                  l’exception des baies et des ouvrants, si la périodicité des contrôles annuels prévus par le
                  constructeur a
                  été respectée).
                </p>
                <p>
                  <strong>Les pièces de la cellule </strong> : pompe à eau, Carte électronique chauffe-eau, agrégat
                  réfrigérateur, transformateur et chargeur électrique, pulseur d’air, carte électronique du
                  réfrigérateur, à
                  l’exception des faisceaux. Les problèmes d’étanchéité (couverture des dommages résultant d’une
                  modification
                  anormale de la cellule, à l’exception des baies et des ouvrants, si la périodicité des contrôles
                  annuels
                  prévus par le constructeur a été respectée).
                </p>
                <p>
                  <strong>Important </strong> : Cette garantie est réservée aux camping-cars de moins de 5 tonnes et
                  moins de
                  120 000 kilomètres à la souscription.
                </p>
              </div>
            </div>
            <div v-else>
              <div class="garantie-view__body__block--content">
                <h4 class="ql-align-center">
                  <strong>LES PIÈCES GARANTIES (PORTEUR)</strong>
                </h4>
                <div class="description">
                  <div class="list mt-3">
                    <ul class="list__ul">
                      <li>
                        <b>Dans le Moteur :</b>
                        <div>
                          Arbre à cames, coussinets de bielles, bielles, culbuteurs, tiges de culbuteurs, poussoirs,
                          chaines
                          de distribution, courroie de distribution (uniquement en cas de rupture), paliers de
                          vilebrequin,
                          vilebrequin, pistons et axes, segments, soupapes et guides, pompe à huile, culasse et joint de
                          culasse et turbo.
                        </div>
                      </li>
                      <li>
                        <b>Dans la Boite de vitesses :</b>
                        <div>
                          Manuelle : Toutes les défaillances internes : Pignons, arbres, sélecteurs, synchros,
                          roulements.
                        </div>
                        <div>
                          Automatique : Pignons, pompe à huile, bagues et arbres, convertisseur de couple, vannes et
                          soupapes,
                          régulateur, plateau.
                        </div>
                      </li>
                      <li>
                        <b>Dans le dispositif de transmission :</b>
                        <div>
                          Boîte de transfert, pont arrière, différentiels, pignons et couronnes. A l’exclusion des
                          arbres de
                          roues, de transmission et des cardans.
                        </div>
                      </li>
                      <li>
                        <b>Dans le dispositif de refroidissement :</b>
                        <div>Radiateur d'eau, pompe à eau, ventilateur.</div>
                      </li>
                      <li>
                        <b>Dans le système électrique :</b>
                        <div>
                          Alternateur, démarreur, serrure de porte, moteurs et mécanismes de lèves vitres, moteurs
                          d'essuie
                          glace et de toit ouvrant, compresseur et condenseur de climatisation à l’exception de la
                          recharge de
                          gaz.
                        </div>
                      </li>
                      <li>
                        <b>Dans le système de direction :</b>
                        <div>
                          Crémaillère ou boîtier, pompe d'assistance, à l'exception de la colonne, des rotules et
                          biellettes.
                        </div>
                      </li>
                      <li>
                        <b>Dans le système de freinage :</b>
                        <div>Maître cylindre, servofrein, répartiteur, pompe à vide, bloc hydraulique ABS.</div>
                      </li>
                      <li>
                        <b>Dans le système d’alimentation :</b>
                        <div>Allumeur, module électronique d'allumage, bobine, pompe à injection, boîtier électronique
                          d'injection, pompes d'alimentation en carburant, boitier papillon d’injection, débitmètre,
                          vanne
                          EGR. A l'exception des injecteurs.</div>
                      </li>
                      <li>
                        <b>Dans le dispositif d’embrayage :</b>
                        <div>Mécanisme, fourchette, émetteur, récepteur.</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="guaranty.details && guaranty.details.garantie == 3">
            <div class="garantie-view__body__block--content" v-if="!is_LeMondeCampingCar">
              <div class="description">
                <p>
                  <strong>Dans le Moteur</strong> : Arbre à cames, coussinets de bielles, bielles, culbuteurs, tiges de
                  culbuteurs, poussoirs, chaines de distribution, courroie de distribution (uniquement en cas de
                  rupture),
                  paliers de vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides, pompe à huile,
                  culasse
                  et joint de culasse et turbo.
                </p>
                <p><strong>Dans la Boite de vitesses</strong> :</p>
                <p>
                  <strong>Manuelle</strong> : Toutes les défaillances internes : Pignons, arbres, sélecteurs, synchros,
                  roulements.
                </p>
                <p>
                  <strong>Automatique</strong> : Pignons, pompe à huile, bagues et arbres, convertisseur de couple,
                  vannes et
                  soupapes, régulateur, plateau.
                </p>
                <p>
                  <strong>Dans le dispositif de transmission</strong> : Boîte de transfert, pont arrière, différentiels,
                  pignons et couronnes. A l’exclusion des arbres de roues, de transmission et des cardans.
                </p>
                <p>
                  <strong>Dans le dispositif de refroidissement</strong> : Radiateur d'eau, pompe à eau, ventilateur.
                </p>
                <p>
                  <strong>Dans le système électrique</strong> : Alternateur, démarreur, serrure de porte, moteurs et
                  mécanismes de lèves vitres, moteurs d'essuie glace et de toit ouvrant, compresseur et condenseur de
                  climatisation à l’exception de la recharge de gaz.
                </p>
                <p>
                  <strong>Dans le système de direction</strong> : Crémaillère ou boîtier, pompe d'assistance, à
                  l'exception de
                  la colonne, des rotules et biellettes.
                </p>
                <p>
                  <strong>Dans le système de freinage</strong> : Maître cylindre, servofrein, répartiteur, pompe à vide,
                  bloc
                  hydraulique ABS.
                </p>
                <p>
                  <strong>Dans le système d’alimentation</strong> : Allumeur, module électronique d'allumage, bobine,
                  pompe à
                  injection, boîtier électronique d'injection, pompes d'alimentation en carburant, boitier papillon
                  d’injection, débitmètre, vanne EGR et les injecteurs.
                </p>
                <p>
                  <strong>Dans le dispositif d’embrayage</strong> : Mécanisme, fourchette, émetteur, récepteur et volant
                  moteur.
                </p>
                <p>
                  <strong>Les pièces de la cellule</strong> : Pompe à eau, Carte électronique chauffe-eau, agrégat
                  réfrigérateur, transformateur et chargeur électrique, pulseur d’air, carte électronique du
                  réfrigérateur, à
                  l’exception des faisceaux, moteur de lit électrique, mécanisme électrique du marchepied, mécanisme de
                  volet-store, moteur d’antenne électrique. Les problèmes d’étanchéité (couverture des dommages
                  résultant
                  d’une modification anormale de la cellule, à l’exception des baies et des ouvrants, si la périodicité
                  des
                  contrôles annuels prévus par le constructeur a été respectée).
                </p>
                <p>
                  <strong>Important </strong> : Cette garantie est réservée aux camping-cars de moins de 5 tonnes, de
                  moins de
                  10 ans et moins de 120 000 kilomètres à la souscription.
                </p>
              </div>
            </div>
            <div v-else>
              <div class="garantie-view__body__block--content">
                <h4 class="ql-align-center">
                  <strong>LES PIÈCES GARANTIES (PORTEUR)</strong>
                </h4>
                <div class="description">
                  <div class="list mt-3">
                    <ul class="list__ul">
                      <li>
                        <b>Dans le Moteur :</b>
                        <div>
                          Arbre à cames, coussinets de bielles, bielles, culbuteurs, tiges de culbuteurs, poussoirs,
                          chaines
                          de distribution, courroie de distribution (uniquement en cas de rupture), paliers de
                          vilebrequin,
                          vilebrequin, pistons et axes, segments, soupapes et guides, pompe à huile, culasse et joint de
                          culasse et turbo.
                        </div>
                      </li>
                      <li>
                        <b>Dans la Boite de vitesses :</b>
                        <div>
                          Manuelle : Toutes les défaillances internes : Pignons, arbres, sélecteurs, synchros,
                          roulements.
                        </div>
                        <div>
                          Automatique : Pignons, pompe à huile, bagues et arbres, convertisseur de couple, vannes et
                          soupapes,
                          régulateur, plateau.
                        </div>
                      </li>
                      <li>
                        <b>Dans le dispositif de transmission :</b>
                        <div>
                          Boîte de transfert, pont arrière, différentiels, pignons et couronnes. A l’exclusion des
                          arbres de
                          roues, de transmission et des cardans.
                        </div>
                      </li>
                      <li>
                        <b>Dans le dispositif de refroidissement :</b>
                        <div>Radiateur d'eau, pompe à eau, ventilateur.</div>
                      </li>
                      <li>
                        <b>Dans le système électrique :</b>
                        <div>
                          Alternateur, démarreur, serrure de porte, moteurs et mécanismes de lèves vitres, moteurs
                          d'essuie
                          glace et de toit ouvrant, compresseur et condenseur de climatisation à l’exception de la
                          recharge de
                          gaz.
                        </div>
                      </li>
                      <li>
                        <b>Dans le système de direction :</b>
                        <div>
                          Crémaillère ou boîtier, pompe d'assistance, à l'exception de la colonne, des rotules et
                          biellettes.
                        </div>
                      </li>
                      <li>
                        <b>Dans le système de freinage :</b>
                        <div>Maître cylindre, servofrein, répartiteur, pompe à vide, bloc hydraulique ABS.</div>
                      </li>
                      <li>
                        <b>Dans le système d’alimentation :</b>
                        <div>Allumeur, module électronique d'allumage, bobine, pompe à injection, boîtier électronique
                          d'injection, pompes d'alimentation en carburant, boitier papillon d’injection, débitmètre,
                          vanne
                          EGR. A l'exception des injecteurs.</div>
                      </li>
                      <li>
                        <b>Dans le dispositif d’embrayage :</b>
                        <div>Mécanisme, fourchette, émetteur, récepteur.</div>
                      </li>
                      <li>
                        <b>Les pièces de la cellule :</b>
                        <div>Pompe à eau, Carte électronique chauffe-eau, agrégat réfrigérateur, transformateur et
                          chargeur
                          électrique, pulseur d’air, carte électronique du réfrigérateur, à l’exception des faisceaux,
                          moteur
                          de lit électrique, mécanisme électrique du marchepied, mécanisme de volet-store, moteur
                          d’antenne
                          électrique. Les problèmes d’étanchéité (couverture des dommages résultant d’une modification
                          anormale de la cellule, à l’exception des baies et des ouvrants, si la périodicité des
                          contrôles
                          annuels prévus par le constructeur a été respectée).</div>
                      </li>
                      <li>
                        <b>Pour la cellule :</b>
                        <div>
                          Pompe à eau, carte électronique chauffe-eau, agrégat réfrigérateur, transformateur et chargeur
                          électrique, pulseur d’air, carte électronique du , à l’exception des faisceaux. Les problèmes
                          d’étanchéité (couverture des dommages résultant d’une modification anormale de la cellule, à
                          l’exception des baies et des ouvrants, si la périodicité des contrôles annuels prévus par le
                          constructeur a été respectée).
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="garantie-view__body__block--content">
              <div class="description">

                <div class="label mt-5">
                  <div class="label--bold">
                    TABLEAU DE REMBOURSEMENT
                  </div>
                </div>

                <table style="width: 100%; border-collapse: collapse; color: black;" class="mt-5">
                  <thead style="display: table-header-group;">
                    <tr style="display: table-row;">
                      <th style="border: 1px solid #000; padding: 12px; text-align: left; font-weight: bold;">
                        ÂGE DU CAMPING-CAR AU MOMENT DU SINISTRE
                      </th>
                      <th style="border: 1px solid #000; padding: 12px; text-align: left; font-weight: bold;">
                        PRISE EN CHARGE DE LA FACTURE
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="display: table-row;">
                      <td style="border: 1px solid #000; padding: 12px;">&lt; 4 ANS</td>
                      <td style="border: 1px solid #000; padding: 12px;">100%</td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid #000; padding: 12px;">&lt; 6 ANS</td>
                      <td style="border: 1px solid #000; padding: 12px;">80%</td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid #000; padding: 12px;">&lt; 8 ANS</td>
                      <td style="border: 1px solid #000; padding: 12px;">60%</td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid #000; padding: 12px;">&lt; 10 ANS</td>
                      <td style="border: 1px solid #000; padding: 12px;">50%</td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid #000; padding: 12px;">&gt; 10 ANS</td>
                      <td style="border: 1px solid #000; padding: 12px;">40%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
          <template>
            <div class="garantie-view__body__block--content">
              <div class="description">

                <div class="label mt-5">
                  <div class="label--bold">
                    FRANCHISE
                  </div>
                </div>
                <div>
                  Une franchise de 10% avec un minimum de 76 € sera appliquée sur le montant de tout sinistre pris en
                  charge pour les véhicules de moins de 3.5 T.
                  <br>
                  Une franchise de 20% avec un minimum de 150 € sera appliquée sur le montant de tout sinistre pris en
                  charge pour les véhicules de moins de 3.5 T jusqu’à 5 T.
                </div>

                <div class="label mt-5">
                  <div class="label--bold">
                    PLAFOND DE REMBOURSEMENT
                  </div>
                </div>

                <div v-if="guaranty.details && guaranty.details.garantie == 3">
                  Le montant total des réparations réglée pendant la durée de la présente garantie ne pourra dépasser,
                  ni le montant de l’achat du Camping-car, ni sa valeur vénale, ni le plafond de remboursement par
                  avarie de 4 000 € TTC sur le véhicule porteur et 2 000 € TTC sur la Cellule du Camping-Car.
                </div>
                <div v-else>
                  Le montant total des réparations réglée pendant la durée de la présente garantie ne pourra dépasser,
                  ni le montant de l’achat du Camping-car, ni sa valeur vénale, ni le plafond de remboursement par
                  avarie de 2 300 € TTC sur le véhicule porteur et 1 000 € TTC sur la Cellule du Camping-Car.
                </div>

              </div>
            </div>
          </template>

        </div>

        <div class="garantie-view__body__block--content">
          <div class="description">
            <!--<div class="insurance-info">-->
            <!--<div class="insurance-info__buttons">-->
            <!--<div class="insurance-info__buttons__item insurance-info__buttons__item&#45;&#45;33">-->
            <!--<div class="insurance-info__buttons&#45;&#45;wrapper">-->
            <!--<a href="#" @click.prevent="getConfirmationPDF()" class="purple">Confirmation de garantie</a>-->
            <!--<div class="ball-anchor purple"></div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->

            <div class="insurance-info">
              <div class="insurance-info__buttons">
                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                  <div class="insurance-info__buttons--wrapper">
                    <router-link :to="/garantie-camping-car/ + $route.params.id" class="blue">
                      Modifier
                    </router-link>
                    <div class="ball-anchor blue"></div>
                  </div>
                </div>
                <template v-if="getGarantiePrice && checkValidPTC">
                  <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                    <div class="insurance-info__buttons--wrapper" v-if="mechanicCode != '705223'">
                      <a href="#" @click.prevent="checkSubscription(guaranty, getPDF)" class="purple">Souscrire à la
                        garantie</a>
                      <div class="ball-anchor purple"></div>
                    </div>
                    <div class="insurance-info__buttons--wrapper" v-else>
                      <a href="#" @click.prevent="checkSubscription(guaranty, getPDFWL)" class="purple">Souscrire à la
                        garantie</a>
                      <div class="ball-anchor purple"></div>
                    </div>
                  </div>
                  <div class="insurance-info__buttons__item insurance-info__buttons__item--33"
                    v-if="guaranty.mechanic.client_payment == 1">
                    <!-- <div class="col-6 text-right insurance-info__buttons--wrapper">
                                      <a href="#" @click.prenevt="checkSubscription(insurance, resendEmail)" class="green">Envoyer devis par email</a>
                                      <div class="ball-anchor green"></div>
                                    </div> -->
                    <!-- <div class="col-6 text-right insurance-info__buttons--wrapper" v-if="getPrice">
                      <a href="#" @click.prevent="
                          checkSubscription(insurance, resendEmail)
                        " class="green">Envoyer devis par email</a>
                      <div class="ball-anchor green"></div>
                    </div>
                    <div class="col-6 text-right insurance-info__buttons--wrapper" v-else>
                      <a href="#" @click.prevent="confirmSubscription" class="green">Envoyer devis par email</a>
                      <div class="ball-anchor green"></div>
                    </div> -->
                  </div>
                </template>
                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                  <div class="insurance-info__buttons--wrapper">
                    <router-link v-if="!showRetourButton" :to="'/'" class="black">Fermer</router-link>
                    <router-link v-else :to="'/devis'" class="black">Fermer</router-link>
                    <div class="ball-anchor black"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from "@/components/Preloader";
import insuranceMethods from "../../mixins/insuranceMethods";
import { CLIENT_CIVILITY } from "../../constants/client";

export default {
  name: "GarantieCampingCarView",
  components: {
    Preloader,
  },
  mixins: [insuranceMethods],
  data() {
    return {
      guaranty: {},
      isBusy: false,
      isBusyResend: false,
      gender_list: ["M", "Mlle", "Mme", "Société"],
      family_status_list: ["Célibataire", "Marié(e)"],
      professions_list: [
        "",
        "Artisant/commerçant",
        "Exploitant agricole",
        "Profession libérale",
        "Chef d'entreprise",
        "Salarié",
        "Fonctionnaire",
        "VRP",
        "Etudiant",
        "Sans profession",
        "Retraité",
      ],
      guaranty_list: ["", "Réseau", "Maxi Réseau", "Maxi Plus"],
      duration_list: ["", "6 Mois", "12 Mois", "24 Mois", "36 Mois", "48 Mois"],
      assistance_list: ["Pack Assistance", "Sans pack assistance"],
      showRetourButton: false,
      CLIENT_CIVILITY,
      pdfWindow: null,
      numberOfDuplicates: 0,
    };
  },
  computed: {
    getDownloadLinkConfirmationPdf() {
      if (this.guaranty.id)
        return this.getApiAuthUrl(
          "garantie/confirmation-pdf/" + this.guaranty.id
        );

      return "";
    },
    showGender() {
      return this.gender_list[this.guaranty.client.civility]
        ? this.gender_list[this.guaranty.client.civility]
        : "";
    },
    showFamilyStatus() {
      return this.family_status_list[this.guaranty.client.family]
        ? this.family_status_list[this.guaranty.client.family]
        : "";
    },
    showProfession() {
      return this.professions_list[this.guaranty.client.profession]
        ? this.professions_list[this.guaranty.client.profession]
        : "";
    },
    // Details
    showGuaranty() {
      if (this.guaranty.mechanic_id == 4885) {
        if (typeof this.guaranty.details.garantie === 'string') {
          let garantie = parseInt(this.guaranty.details.garantie);
          if (garantie > 0) {
            return this.guaranty_list[garantie] ? this.guaranty_list[garantie] : "";
          }
        } else if (typeof this.guaranty.details.garantie === 'number') {
          let garantie = this.guaranty.details.garantie;
          if (garantie > 0) {
            return this.guaranty_list[garantie] ? this.guaranty_list[garantie] : "";
          }
        }
        let garantie = parseInt(this.guaranty.guarantee) - 1;
        return this.guaranty_list[garantie] ? this.guaranty_list[garantie] : "";
      }
      return this.guaranty_list[this.guaranty.details.garantie ? this.guaranty.details.garantie : this.guaranty.guarantee]
        ? this.guaranty_list[this.guaranty.details.garantie ? this.guaranty.details.garantie : this.guaranty.guarantee]
        : "";
    },
    showDuration() {
      if (this.guaranty && this.guaranty.details && this.guaranty.details.duration) {
        return this.duration_list[this.guaranty.details.duration]
          ? this.duration_list[this.guaranty.details.duration]
          : "";
      } else if (this.guaranty && this.guaranty.details_camping_car && this.guaranty.details_camping_car.duration) {
        return this.duration_list[parseInt(this.guaranty.details_camping_car.duration)]
          ? this.duration_list[parseInt(this.guaranty.details_camping_car.duration)]
          : "";
      }
    },
    showAssistance() {
      return this.assistance_list[this.guaranty.details.assistance]
        ? this.assistance_list[this.guaranty.details.assistance]
        : "";
    },
    getDownloadLink() {
      if (this.guaranty.id) {
        if (this.$store.getters.isLeMondeCampingCar) {
          // alert('LMCC');
          return this.getApiAuthUrl("garantie/generate-lmcc-pdf/" + this.guaranty.id);
        }
        else
          return this.getApiAuthUrl("garantie/generate-pdf/" + this.guaranty.id);
      }

      return "";
    },
    getDownloadLinkWL() {
      if (this.guaranty.id)
        return this.getApiAuthUrl(
          "garantie/generate-pdfWL/" + this.guaranty.id
        );

      return "";
    },
    getDownloadLinkCopyPdf() {
      if (this.guaranty.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdf/" + this.guaranty.id
        );

      return "";
    },
    getDownloadLinkCopyPdfWL() {
      if (this.guaranty.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdfWL/" + this.guaranty.id
        );

      return "";
    },
    getPrice() {
      return this.guaranty.price
        ? this.roundEURWithoutSymbol(this.guaranty.price).replace(".", ",") +
        " €"
        : "";
    },
    getGarantiePrice() {
      return this.guaranty.price && +this.guaranty.price > 0;
    },
    checkValidPTC() {
      if (this.guaranty.details && this.guaranty.details.ptc && this.guaranty.details.ptc == 3) {
        return false;
      }
      return true;
    },
    mechanicCode() {
      let code =
        this.$store.state.userInfo && this.$store.state.userInfo.mechanic
          ? this.$store.state.userInfo.mechanic.code
          : null;
      return code ? code : "";
    },
    is_LeMondeCampingCar() {
      if (this.$store.getters.isLeMondeCampingCar)
        return true;
      else
        return false;
    },
  },
  methods: {
    confirmSubscription() {
      this.$confirm({
        message:
          "Les critères du véhicule ne permettent pas de souscrire à la garantie choisie. Etes-vous sûr de vouloir envoyer un devis sans prix à votre client ?",
        button: {
          no: "Non",
          yes: "Oui"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            this.checkSubscription(this.insurance, this.resendEmail)
          }
        }
      });
    },
    parseCirculationDate(details) {
      if (!details) return "";

      if (details.date_circulation_formated) {
        return this.moment(details.date_circulation_formated).format("DD/MM/YYYY");
      }

      if (!details.day_circulation && !details.month_circulation && !details.year_circulation) return "";

      let day = details.day_circulation,
        month = details.month_circulation - 1,
        year = details.year_circulation;

      day.length < 2 ? (day = "0" + day.toString()) : "";
      month.length < 2 ? (month = "0" + month.toString()) : "";

      let date = this.moment(new Date()).date(day).month(month).year(year);
      return date.format("DD/MM/YYYY");
    },
    parseSaleDate(quoteDatails) {
      if (quoteDatails.sale_date) {
        return this.moment(quoteDatails.sale_date).format("DD/MM/Y");
      }

      return "";
    },
    parseEffectiveDate(quoteDatails) {
      if (quoteDatails.effective_date) {
        // let day = quoteDatails.datesParse.day_effective,
        //     month = quoteDatails.datesParse.month_effective,
        //     year = quoteDatails.datesParse.year_effective;
        return this.moment(quoteDatails.effective_date).format("DD/MM/Y");
      }

      return "";
    },
    parseDeliveryDate(quoteDatails) {
      if (quoteDatails.delivery_date) {
        // let day = quoteDatails.datesParse.day_delivery,
        //     month = quoteDatails.datesParse.month_delivery,
        //     year = quoteDatails.datesParse.year_delivery;
        return this.moment(quoteDatails.delivery_date).format("DD/MM/Y");
      }

      return "";
    },
    parseBirthDate(quoteDatails) {
      if (quoteDatails.client.birthday) {
        let day = quoteDatails.client.datesParse.day_birth,
          month = quoteDatails.client.datesParse.month_birth,
          year = quoteDatails.client.datesParse.year_birth;
        return this.moment(quoteDatails.client.birthday).format("DD/MM/Y");
      }

      return "";
    },
    getGuarantyInfo() {
      this.isBusy = true;
      let url = "garantie/" + this.$route.params.id;
      this.apiGet(url)
        .then((response) => {
          this.guaranty = response.data.quote ? response.data.quote : {};
          this.numberOfDuplicates = response.data.duplicates;
          this.isBusy = false;
        })
        .catch((error) => {
          this.showErrorNotification(error);
          this.$router.push("/");
        });
    },
    printInsurance() {
      window.print();
    },
    resendEmail() {
      this.isBusyResend = true;
      let url = "garantie/resend-email/" + this.guaranty.id;

      this.apiPost(url, {})
        .then((response) => {
          this.isBusyResend = false;
          if (response.data.quote && response.data.status == "success") {
            this.showSuccessNotification(response.data.message, "");
            this.$set(this.guaranty, "was_sent", response.data.quote.was_sent);
          }
        })
        .catch((error) => {
          this.isBusyResend = false;
          this.showErrorNotification(error);
        });
    },
    getPDF() {
      if (this.checkEffectiveDate(this.guaranty)) {
        this.refreshTokenForce()
          .then((response) => {
            if (this.getDownloadLink) {
              let pdfWindow = window.open(this.getDownloadLink);
              if (pdfWindow) this.pdfWindow = pdfWindow;
            } else {
              this.showWarningNotification("Quote Not Found");
            }
          })
          .catch((error) => {
            this.showErrorNotification(error);
          });
      } else {
        this.showWarningNotification(
          "La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d'effet de la garantie."
        );
      }
    },
    getConfirmationPDF() {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkConfirmationPdf) {
            window.location = this.getDownloadLinkConfirmationPdf;
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorNotification(error);
        });
    },
    getFrontPdf() {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkCopyPdf) {
            window.open(this.getDownloadLinkCopyPdf);
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    getIsNew() {
      if (typeof this.guaranty.details.is_new === 'number') {
        return (this.guaranty.details.is_new == 1) ? 'Oui' : 'Non';
      } else if (typeof this.guaranty.details.is_new === 'string') {
        if (this.guaranty.details.is_new == '1') return 'Oui';
        if (this.guaranty.details.is_new == '0') return 'Non';
        return this.guaranty.details.is_new;
      }
      return this.guaranty.details.is_new;
    }
  },
  mounted() {
    this.getGuarantyInfo();
    this.$eventBus.$emit("sidebar-set-active-tab", "Garantie Camping Car");

    if (this.$store.state.backToDevisListActive) {
      this.showRetourButton = true;
      this.$store.dispatch("backToDevisDisable");
    }
  },
  beforeDestroy() {
    this.$eventBus.$emit("sidebar-set-active-tab", "");
  },
  watch: {
    pdfWindow: function () {
      window.location.href = "/merci";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/GarantieCampingCarView.vue